import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

import { QuestionType } from '../../core';
import { EvalFormValue } from '../model/eval-form-value.model';
import { QuestionFormValue } from '../model/question-form-value.model';

import { scorePercentage } from './score-percentage.function';

function radioQuestionIsExcluded(qv: QuestionFormValue): boolean {
    if (qv.type !== QuestionType.RadioButton) {
        return false;
    }

    const opt = qv.options?.find((e) => e.optionId === qv.optionId);
    if (opt == null) {
        return false;
    }

    return opt.excludedFromAutoFailRules === true;
}

export function checkScore(
    form: FormGroup,
    value: EvalFormValue,
): {
    value: EvalFormValue;
    evalFail: boolean;
    groupFails: AbstractControl[];
    sectionFails: AbstractControl[];
    questionFails: AbstractControl[];
} {
    const nextValue: EvalFormValue = JSON.parse(JSON.stringify(value));
    let evalFail = false;
    const groupFails: AbstractControl[] = [];
    const sectionFails: AbstractControl[] = [];
    const questionFails: AbstractControl[] = [];

    (form?.controls?.groups as FormArray).controls.forEach((g, gi) => {
        const gv = nextValue.groups[gi];
        let gvHasChildError = false;

        ((g as FormGroup)?.controls?.sections as FormArray).controls.forEach(
            (s, si) => {
                const sv = nextValue.groups[gi].sections[si];
                let svHasChildError = false;

                /* validating here because values also need to change. it seems weird, but it's fine i guess */
                (
                    (s as FormGroup)?.controls?.questions as FormArray
                ).controls.forEach((q, qi) => {
                    const qv = nextValue.groups[gi].sections[si].questions[qi];
                    qv.hasChildError = false;

                    if (radioQuestionIsExcluded(qv)) {
                        return;
                    }

                    const scoringConstraints = qv.scoreConstraints?.filter(
                        (sc) => {
                            return (
                                sc.scoreThresholdForFailure == null ||
                                (sc.scoreMustBeLower === true &&
                                    qv.score < sc.scoreThresholdForFailure) ||
                                (sc.scoreMustBeLower === false &&
                                    qv.score > sc.scoreThresholdForFailure)
                            );
                        },
                    );
                    if (scoringConstraints?.length === 0) {
                        return;
                    }
                    scoringConstraints?.forEach((sc) => {
                        if (sc.hasSectionFail === true) {
                            nextValue.score = Math.max(
                                0,
                                nextValue.score - sv.score,
                            );
                            gv.score = Math.max(0, gv.score - sv.score);
                            sv.score = 0;
                            sectionFails.push(s);
                            questionFails.push(q);
                            qv.hasChildError = true;
                        }
                        if (sc.hasGroupFail === true) {
                            gv.score = 0;
                            groupFails.push(g);
                            qv.hasChildError = true;
                        }
                        if (sc.hasOverallEvalFail === true) {
                            nextValue.score = 0;
                            evalFail = true;
                            qv.hasChildError = true;
                        }
                    });
                    svHasChildError = qv.hasChildError;
                });

                sv.percentage = scorePercentage(sv.score, sv.diffMaxScore);
                sv.hasChildError = svHasChildError;
                gvHasChildError = gvHasChildError || sv.hasChildError;
            },
        );

        gv.percentage = scorePercentage(gv.score, gv.diffMaxScore);
        gv.hasChildError = gvHasChildError;
    });

    nextValue.percentage = scorePercentage(
        nextValue.score,
        nextValue.diffMaxScore,
    );

    return {
        value: nextValue,
        evalFail,
        groupFails,
        sectionFails,
        questionFails,
    };
}
